import React, { useState } from 'react'
import TooltipIcon from '../TooltipIcon/TooltipIcon';
import Select from 'react-select';
import CustomMenuList from '../CustomMenuList/CustomMenuList';

const DropdownRowWSearchFilter = ({ name, question, options, value, onChange, defaultValue = "", onTooltipClick, display = true }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');

    if (!display) {
        return null;
    }

    // Separate "Unknown / Not Listed" from the rest
    const staticOption = options.find(opt => opt.value === 'Unknown / Not Listed');
    const filteredOptions = options.filter(opt => opt.value !== 'Unknown / Not Listed');

    return (
        <div className="row form-group form-group-sm align-items-center my-3">
            <div className="col-12 col-md-6 text-primary fw-bold mb-2 mb-md-0 fs-6">
                {question}
                {onTooltipClick && <TooltipIcon onClick={onTooltipClick} />}
            </div>
            <div className="col-12 col-md-6 col-sm-8">
                <Select
                    className="col-sm-12"
                    classNamePrefix="custom-select"
                    options={filteredOptions}
                    value={value ? [...filteredOptions, staticOption].find(opt => opt.value === value) : null}
                    onChange={onChange}
                    menuIsOpen={menuIsOpen}
                    onMenuOpen={() => setMenuIsOpen(true)}
                    onMenuClose={() => setMenuIsOpen(false)}
                    placeholder="Start typing to search..."
                    noOptionsMessage={() => 'No results found'}
                    filterOption={(option, input) =>
                        option.value.toLowerCase().includes(input.toLowerCase())
                    }
                    inputValue={inputValue}
                    onInputChange={(val) => setInputValue(val)}
                    components={{ MenuList: CustomMenuList }}
                    styles={{
                        container: base => ({ ...base, width: '100%' }),
                        menuList: base => ({ ...base, maxHeight: '180px', paddingBottom: 0 }),
                        option: base => ({ ...base, cursor: 'pointer' })
                    }}
                    staticOption={staticOption}
                    setMenuIsOpen={setMenuIsOpen}
                    clearInputValue={() => setInputValue('')}
                />
            </div>
        </div>
    );
}

export default DropdownRowWSearchFilter